import React from "react";
import ProductInfo from "./info/ProductInfo";

export const productSidebarSections = [
  { id: 1, title: "dane produktu", component: <ProductInfo /> },
];
